import { render, staticRenderFns } from "./KanTuXieZuo.vue?vue&type=template&id=61839739&scoped=true"
import script from "./KanTuXieZuo.vue?vue&type=script&lang=js"
export * from "./KanTuXieZuo.vue?vue&type=script&lang=js"
import style0 from "./KanTuXieZuo.vue?vue&type=style&index=0&id=61839739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61839739",
  null
  
)

export default component.exports